import { createContext } from 'react'
import type { SnackbarOptions, SnackbarKey, SnackbarMessage, Toast } from './types'

export type SnackbarContextProps = {
  addToast: (message: SnackbarMessage, toast?: SnackbarOptions) => SnackbarKey
  removeToast: (key: Toast['key']) => void
  dismissAll: () => void
}

export type SnackbarContent = Partial<Record<NonNullable<Toast['position']>, Toast[]>>

export const defaultValue = {}

export const SnackbarContext = createContext<SnackbarContextProps>(defaultValue as SnackbarContextProps)
